// apps/pwa-pos/src/lib/bootstrap.ts
// Sprint 99 POS.5 — mantenimiento de datos locales previo al render.
//
// I6 del review final: la migración se lanzaba con `void` y React montaba en
// paralelo. `SyncIndicator` y la carga de catálogo de `SalePage` pegaban contra
// IndexedDB con la transacción de migración todavía abierta, y una venta
// cobrada en esa ventana calculaba su consecutivo sobre una cola sin los
// registros migrados: código duplicado.
//
// Además `purgarHistorialAntiguo` estaba encadenado detrás de la migración, así
// que una migración fallida desactivaba la purga para siempre.
//
// Nada de esto puede impedir que la app arranque: el fallo se publica y se
// sigue. Vive en `lib/` para poder testearlo — los tests de este paquete corren
// en node sin jsdom, así que `main.tsx` queda como un wrapper delgado.

import { migrarDesdeLocalStorage } from './db-migration';
import { registrarProblemasMigracion } from './migracion-problemas';
import { purgarHistorialAntiguo } from './sync-queue';

export async function prepararDatosLocales(): Promise<void> {
  try {
    const res = await migrarDesdeLocalStorage();
    registrarProblemasMigracion(res.problemas);
  } catch (err) {
    const detalle = err instanceof Error ? err.message : String(err);
    registrarProblemasMigracion([
      `La migración de datos locales no se completó: ${detalle}. Los datos siguen en este equipo.`,
    ]);
    console.error('[db] migracion IDB fallo:', err);
  }

  // Corre siempre, incluso si la migración falló: la purga no depende de ella.
  try {
    await purgarHistorialAntiguo();
  } catch (err) {
    console.warn('[db] purga de historial fallo:', err);
  }
}
